import keyMirror from 'keymirror'

export default keyMirror({
  GET_HELP_DESKS_REQUEST: null,
  GET_HELP_DESKS_SUCCESS: null,
  GET_HELP_DESKS_FAILED: null,

  GET_HELP_DESK_DETAIL_REQUEST: null,
  GET_HELP_DESK_DETAIL_SUCCESS: null,
  GET_HELP_DESK_DETAIL_FAILED: null,

  DELETE_HELP_DESK_REQUEST: null,
  DELETE_HELP_DESK_SUCCESS: null,
  DELETE_HELP_DESK_FAILED: null,

  ADD_HELP_DESK_REQUEST: null,
  ADD_HELP_DESK_SUCCESS: null,
  ADD_HELP_DESK_FAILED: null,

  UPDATE_HELP_DESK_REQUEST: null,
  UPDATE_HELP_DESK_SUCCESS: null,
  UPDATE_HELP_DESK_FAILED: null,

  UPDATE_HELP_DESK_STATUS_REQUEST: null,
  UPDATE_HELP_DESK_STATUS_SUCCESS: null,
  UPDATE_HELP_DESK_STATUS_FAILED: null,

  UPDATE_FILTER_HELP_DESK_SUCCESS: null,

  UPDATE_HELP_DESK_SELECTED_LANGUAGES_SUCCESS: null,

  UPSERT_HELP_DESK_TRANSLATION_REQUEST: null,
  UPSERT_HELP_DESK_TRANSLATION_SUCCESS: null,
  UPSERT_HELP_DESK_TRANSLATION_FAILED: null
})
